import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { AttachmentsViewer } from 'src/Components/Shared/AttachmentsViewer';
import { KeyValueLine } from 'src/Components/Shared/KeyValueLine';
import useFetchExportedPracticalInformation from 'src/Hooks/Queries/useFetchExportedPracticalInformation';
import { CreatePracticalInformationFieldDtoFieldTypeEnum } from 'src/Services/API/generated';
import { humanizeRRule, isRecurrenceDto } from 'src/Services/Shared/humanizeRRule';

import styles from './ExportedPracticalInformationWrapper.module.scss';

interface Props {
  token: string;
  practicalInformationId: string;
}

const ExportedPracticalInformationWrapper = ({ token, practicalInformationId }: Props) => {
  const { data: information } = useFetchExportedPracticalInformation({
    token,
    practicalInformationId,
  });
  const { t, i18n } = useTranslation();

  if (!information) return null;

  const title = information.subtype
    ? t(`practicalInformation.subtypes.${information.subtype}`)
    : information.title;

  return (
    <div className={styles.container}>
      <div className={styles.title}>{title}</div>
      {information.fields
        .filter(field => Boolean(field.value))
        .map((field, index) => (
          <KeyValueLine
            key={index}
            propertyKey={t(`practicalInformation.placeholders.${field.key}`)}
            value={
              field.fieldType === CreatePracticalInformationFieldDtoFieldTypeEnum.Date
                ? dayjs(field.value.toString()).locale(i18n.language).format('LL')
                : field.fieldType === CreatePracticalInformationFieldDtoFieldTypeEnum.Schedule
                  ? isRecurrenceDto(field.value)
                    ? humanizeRRule(field.value)
                    : 'not a recurrence'
                  : field.value?.toString()
            }
          />
        ))}
      {information.attachments && information.attachments.length > 0 && (
        <AttachmentsViewer attachments={information.attachments} />
      )}
    </div>
  );
};

export default ExportedPracticalInformationWrapper;
